import { useEffect, useState, useMemo, useRef } from 'react';
import useSwr, { mutate } from 'swr'
import isEqual from 'react-fast-compare';

import { apiFetch } from '../../../services'
import { firstValid, getObjectValue } from "../utils";
import { asBool } from '../form/input/utils';

const deepCopy = obj => obj === undefined ? obj : JSON.parse(JSON.stringify(obj))

const Reader = ({ name, method, property, path, context, data, dispatch, action, overwrite, interval }) => {
	const [ctxDispatch, account] = [context.dispatch, context?.scope?.current]
	const prp = useMemo(() => JSON.stringify(property ? property : {}), [property])
	const datakey = useMemo(() => method ? ['/exec', method, account, prp] : null, [method, account, prp])
	const [currentData, setCurrentData] = useState(deepCopy(getObjectValue(data, path)))

	const {
		data: _newData,
		isValidating: loading
	} = useSwr(datakey, (key, method, account, property) => apiFetch(key, { method, ...(JSON.parse(property)) }, account), {
		focusThrottleInterval: 30000,
		dedupingInterval: parseInt(interval) ? 1000 : 5000,
		refreshInterval: parseInt(interval) ? parseInt(interval) * 1000 : 0
	})

	const newData = useMemo(() => datakey ? _newData : getObjectValue(data, path), [datakey, _newData, data, path])
	
	/* 
	const [_cacheData, setCacheData] = useState(() => datakey ? null : getObjectValue(data, path))
	const newData = datakey ? _newData : _cacheData;

	useEffect ( () => {
	  if (!datakey) {
	    const value = getObjectValue(data, path)
	    
	    setCacheData( old => {
	      if (isEqual(old, value))
	      { 
		return old 
	      } else { 
		console.log('new data in reader2', path, old === value);
		return value 
	      }
	    })
	  }
	}, [datakey, data, path] )

	useEffect ( () => {
	  console.log('reader', name, 'defining dispatch')
	  return () => { console.log('reader', name, 'unmounting dispatch') }
	}, [name, dispatch])

	const actionRef = useRef(action);
	const actionDefined = !!action;

	useEffect (() => {
	  actionRef.current = action;
	  return () => { actionRef.current = null };
	}, [action])
	*/

	useEffect(() => {
		const equalResult = isEqual(currentData, newData)

		if (!equalResult) {
			console.log("new data in reader:", name);

			if (datakey && newData) {
				setCurrentData(newData);
				dispatch({ type: "set-data", path, payload: newData, override: asBool(firstValid(overwrite, true)) });
			} else {
				setCurrentData(deepCopy(newData));
			}
			//if (!!actionRef.current) actionRef.current({ reader: name, old: currentData })();
			action({ reader: name, old: currentData })();
		}
	}, [currentData, name, newData, path, dispatch, datakey, overwrite, action])

	useEffect(() => {
		if (loading) {
			ctxDispatch({ type: "refreshing" })
			return () => ctxDispatch({ type: "refreshed" })
		}
	}, [ctxDispatch, loading])

	useEffect(() => {
		if (!loading && context.shouldRefresh && datakey) {
			mutate(datakey)
		}
	}, [loading, context.shouldRefresh, datakey])

	return null
}


export default Reader
